import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {OnboardingDialogNextDefaultBox} from "./onboarding-dialog-next.default.box";
import {OnboardingDialogNextMrGreenBox} from "./onboarding-dialog-next.mrgreen.box";
import {OnboardingDialogNextCasino777Box} from "./onboarding-dialog-next.casino777.box";

export const OnboardingDialogNextBox = styledByTheme(OnboardingDialogNextDefaultBox)
    .forMrGreen(OnboardingDialogNextMrGreenBox)
    .forCasino777(OnboardingDialogNextCasino777Box)
    .apply();
